import {
    Avatar,
    AvatarBadge,
    Box,
    Button,
    Flex,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Spinner,
    Tag,
    TagLabel,
    TagLeftIcon,
    Text
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MdArrowDownward, MdExitToApp } from "react-icons/md";
import { Link, Redirect, useHistory } from "react-router-dom";
import { AccountRole, useMeQuery } from "../../graphql";
import { useLogout } from "../../hooks";
import { ShortAccount, getFullName } from "../../utils";

const Profile: React.FC = () => {
    const { t } = useTranslation();

    const roleLabel = {
        [AccountRole.Admin]: t("roles.admin"),
        [AccountRole.Author]: t("roles.author"),
        [AccountRole.Doctor]: t("roles.doctor"),
        [AccountRole.MedicalSpecialist]: t("roles.specialist")
    };

    const { data, loading, error } = useMeQuery();
    const history = useHistory();
    const logout = useLogout();

    if (loading) {
        return <Spinner />;
    }

    if (error) {
        return <Redirect to="/login" />;
    }
    // const fullName = getFullName(data.me);

    return (
        <Flex
            height="70px"
            justifyContent="space-between"
            alignItems="center"
            padding="16px"
        >
            <Avatar
                name={ getFullName(data.me as ShortAccount) }
                width="40px"
                height="40px"
                src={ data.me.profileImage }
            >
                <AvatarBadge
                    size="14px"
                    bottom="2px"
                    right="2px"
                    bg="green.500"
                    border="1px"
                    borderColor="gray.200"
                />
            </Avatar>
            <Flex flexDir="column" mx="10px" pt="5px" width="100%">
                <Text lineHeight="1" fontWeight="bold" color="gray.700">
                    { getFullName(data.me as ShortAccount) }
                </Text>
                <Text fontSize="11px" color="#777777">
                    { roleLabel[data.me.role] }
                </Text>
                <Menu size="sm">
                    <MenuButton size="xs" as={ Button } rightIcon={ <MdArrowDownward /> }>
                        { t("account.myAccount") }
                    </MenuButton>
                    <MenuList>
                        <Link to="/my-account">
                            <MenuItem>{ t("account.profile") }</MenuItem>
                        </Link>
                        <MenuItem
                            onClick={ () => {
                                logout();
                            } }
                        >
                            { t("account.logout") }
                        </MenuItem>
                    </MenuList>
                </Menu>
            </Flex>
        </Flex>
    );
};

export default Profile;
